import React from 'react'
import { makeStyles } from '@material-ui/core'
import { PieChart } from 'react-minimal-pie-chart'
import SummaryStatItem from './SummaryStatItem'
import generateRiskCounts from '../ultils/generateRiskCounts'

const useStyles = makeStyles(theme => {
  return {
    indexBoard: {
      marginBottom: 30,
    },
    typeContainer: {
      width: 'calc(100% - 150px)',
    },
    pieChart: {
      position: 'relative',
      height: '84px',
      width: '84px',
      minWidth: '84px',
    },
    innerBox: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '84px',
      width: '84px',
      pointerEvents: 'none',
    },
    numberText: {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '26px',
      color: '#1B3963',
    },
    titleContainer: {
      marginBottom: 27,
    },
    title: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1B3963',
    },
    subtitle: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      color: '#474747',
    },
    leftSide: {},
    pieChartContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
  }
})

interface SummaryStatsBoxProps {
  total: number
  data: any
  title: string
}

const LastWeekStatsMobile = ({ total, data, title }: SummaryStatsBoxProps) => {
  const classes = useStyles()
  const count = data[0] ? data[0].count : 0
  return (
    <div className={classes.indexBoard}>
      <div className={classes.titleContainer}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{`${count} companies`}</div>
      </div>
      <div className={classes.pieChartContainer}>
        <div className={classes.pieChart}>
          <PieChart
            animate
            animationDuration={500}
            animationEasing="ease-out"
            lineWidth={30}
            radius={42}
            viewBoxSize={[84, 84]}
            center={[42, 42]}
            data={data}
          />
          <div className={classes.innerBox}>
            <div className={classes.numberText}>{count}</div>
          </div>
        </div>

        <div className={classes.typeContainer}>
          {data
            .filter((d: any) => d.title !== 'Total')
            .map((d: any) => (
              <SummaryStatItem d={d} total={total} key={d.title} />
            ))}
        </div>
      </div>
    </div>
  )
}

export default LastWeekStatsMobile
